import {Box, CircularProgress, Grid} from "@mui/material";
import React, {useMemo, useState} from "react";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {useMaliRaporlar} from "./hooks/useMaliRaporlar";
import GelirlerTablosu from "./components/GelirlerTablosu";
import AylikGelirGiderTablosu from "./components/AylikGelirGiderTablosu";

dayjs.extend(customParseFormat);

interface ShowSeriesState {
    satis: boolean;
    gider: boolean;
    mas15: boolean;
    mas30: boolean;
    mas90: boolean;
    mag15: boolean;
    mag30: boolean;
    mag90: boolean;
}

const MaliTablolar = () => {
    const {gunlukVeri, aylikVeri, isLoading} = useMaliRaporlar();
    const [seciliDonem, setSeciliDonem] = useState<string>();
    const [baslangicTarih, setBaslangicTarih] = useState<string>(dayjs().subtract(3, 'month').format('DD-MM-YYYY'));
    const [bitisTarih, setBitisTarih] = useState<string>(dayjs().format('DD-MM-YYYY'));
    const [showSeries, setShowSeries] = useState<ShowSeriesState>({
        satis: false,
        gider: false,
        mas15: false,
        mas30: false,
        mas90: true,
        mag15: false,
        mag30: false,
        mag90: true,
    });

    const toggleSeries = (seriesName: keyof ShowSeriesState) => {
        setShowSeries((prev) => ({
            ...prev,
            [seriesName]: !prev[seriesName],
        }));
    };

    const seciliTarihler = useMemo(() => {
        return Object.keys(gunlukVeri)
            .filter((tarih) => {
                const date = dayjs(tarih, "DD-MM-YYYY");
                const start = dayjs(baslangicTarih, "DD-MM-YYYY");
                const end = dayjs(bitisTarih, "DD-MM-YYYY");
                
                const baslangic = baslangicTarih !== "" ? (date.isAfter(start, 'day') || date.isSame(start, 'day')) : true;
                const bitis = bitisTarih !== "" ? (date.isBefore(end, 'day') || date.isSame(end, 'day')) : true;
                return baslangic && bitis;
            })
            .sort((a, b) => {
                return dayjs(a, "DD-MM-YYYY").unix() - dayjs(b, "DD-MM-YYYY").unix();
            });
    }, [gunlukVeri, baslangicTarih, bitisTarih]);

    const donemler = useMemo(() => {
        return Object.keys(aylikVeri)
            .sort((a, b) => {
                const aDate = dayjs("01-" + a, "DD-MM-YYYY");
                const bDate = dayjs("01-" + b, "DD-MM-YYYY");
                return aDate.unix() - bDate.unix();
            })
            .slice(-12);
    }, [aylikVeri]);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="400px">
                <CircularProgress/>
            </Box>
        );
    }

    const mevcutDonem = donemler[donemler.length - 1];

    return (
        <Box sx={{ mt: 1 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <GelirlerTablosu
                        baslangicTarih={baslangicTarih}
                        setBaslangicTarih={setBaslangicTarih}
                        bitisTarih={bitisTarih}
                        setBitisTarih={setBitisTarih}
                        showSeries={showSeries}
                        toggleSeries={toggleSeries}
                        seciliTarihler={seciliTarihler}
                        gunlukVeri={gunlukVeri}
                    />
                </Grid>
                <Grid item xs={12}>
                    <AylikGelirGiderTablosu
                        donemler={donemler}
                        aylikVeri={aylikVeri}
                        seciliDonem={seciliDonem}
                        setSeciliDonem={setSeciliDonem}
                        mevcutDonem={mevcutDonem}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default MaliTablolar;
